(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("onlineExamLearnerAccess", {
        templateUrl: "app/account/learnerAccess/learningItemType/onlineExamLearnerAccess.component.html",
        require: {
            parentCtrl: "^^learningItemLearnerAccessModal"
        },
        controller: ["frameworkService", "messageService", "assignmentLearnerAccessOnlineExamResource", "shoppingCartService", "$uibModal", "$localStorage", "$stateParams", "$state", "_", OnlineExamLearnerAccessCtrl],
        controllerAs: "vm"
    });
    function OnlineExamLearnerAccessCtrl(frameworkService, messageService, assignmentLearnerAccessOnlineExamResource, shoppingCartService, $uibModal, $localStorage, $stateParams, $state, _) {
        var vm = this;
        vm.attemptRequested = false;
        vm.attemptRequestDenied = false;
        vm.showErrors = false;
        vm.code = $stateParams.code;
        vm.hasAttemptInProgress = false;
        vm.hasAttemptsAfterRequest = false;
        vm.examAttemptCode = "";
        vm.locale = $localStorage.selectedLanguage.culture;
        vm.frameworkData = frameworkService.data;
        vm.sellExamAttemptsEnabled = frameworkService.data.tenantFeatures.catalogAdvancedVisible && frameworkService.data.tenantFeatures.sellExamAttempts;
        //vm.inventoryEnabled = vm.frameworkData.tenantFeatures.inventory;
        this.$onInit = function () {
            vm.assignment = vm.parentCtrl.assignment;
            load();
        };
        //////////////////////////////////////////////////////////////////////////////
        function load() {
            vm.parentCtrl.buttons = [];
            vm.parentCtrl.haveMultipleButtons = true;
            assignmentLearnerAccessOnlineExamResource.get({ id: vm.assignment.id }, function (result) {
                vm.data = result;
                //2024-11-20 do not show Scheduled attempts
                vm.data.history = _.filter(vm.data.history, function (item) {
                    return item.result !== "Scheduled";
                });
                //if PathExpiryType is Path, and Path is Expiring or Expired, hide launch button.
                if (!vm.assignment.pathExpiringOrExpired || vm.assignment.pathExpiryType === "Items") {
                    vm.hasAttemptInProgress = !_.every(vm.data.history, function (item) {
                        return item.result === "Failed" || item.result === "Passed" || item.result === "accessRemoved";
                    });
                    if (vm.data.lastAttemptRequest && vm.data.lastAttemptRequest.approvedDate)
                        vm.hasAttemptsAfterRequest = _.some(vm.data.history, function (item) {
                            return item.date > vm.data.lastAttemptRequest.approvedDate;
                        });
                    switch (vm.assignment.assignmentStatus) {
                        case 0:
                            vm.parentCtrl.disableGoToExamButton = false;
                            break;
                        case 1:
                        case 2:
                            setupSelectExamSessionButton();
                            setupGoToExamButton();
                            break;
                        case 3:
                            if (vm.assignment.expiring)
                                setupRequalifyButton();
                            else if (vm.assignment.typeId === 12)
                                setupGoToExamButton();
                            break;
                        case 4:
                            setupRequalifyButton();
                            break;
                    }
                    switch (vm.data.proctorTypeId) {
                        case 0:
                            vm.proctor = "learningItem.onlineExam.proctored.notProctored";
                            break;
                        case 1:
                            vm.proctor = "learningItem.onlineExam.proctored.proctored";
                            break;
                    }
                }
                vm.parentCtrl.contentLoaded = true;
            }, function (error) {
                messageService.error(error);
            });
        }
        var setupRequalifyButton = function () {
            vm.parentCtrl.buttons.push("requalifyButton");
            vm.parentCtrl.requalify = vm.requalify;
        };
        var setupGoToExamButton = function () {
            //If Exam is Not Proctored
            var isProctored = vm.data.proctorTypeId === 1;
            //If Exam is Proctored and not Scheduled
            var isProctoredNotScheduled = isProctored && vm.data.isProctoredNotSchedule;
            //If Exam is Proctored and Scheduled and in a session
            var isProctoredScheduledInSession = isProctored && vm.data.examSession;
            var hasInProgOrReady = _.some(vm.data.history, function (item) {
                return item.result === "InProgress" || item.result === "Ready" || item.result === "Scheduled";
            });
            if (hasInProgOrReady || isProctoredScheduledInSession ||
                (vm.data.remainingAttempts > 0 && !vm.hasAttemptInProgress && (!isProctored || isProctoredNotScheduled))) { //||
                vm.parentCtrl.buttons.push("goToExamButton");
                vm.parentCtrl.goToExam = vm.goToExam;
            }
        };
        var setupSelectExamSessionButton = function () {
            console.log("history", vm.data.history);
            var hasInProgOrReady = _.some(vm.data.history, function (item) {
                return item.result === "InProgress" || item.result === "Ready";
            });
            var canEnroll = vm.data.hasUpcomingSessions && vm.data.examSession == null && (vm.data.isProctoredScheduledInPerson || vm.data.isProctoredScheduledOnline);
            if (!hasInProgOrReady && vm.data.remainingAttempts > 0 && !vm.hasAttemptInProgress && canEnroll) {
                vm.parentCtrl.buttons.push("selectExamSessionButton");
                vm.parentCtrl.goToSelectExamSession = vm.goToSelectExamSession;
                return true;
            }
            return false;
        };
        vm.requalify = function () {
            vm.parentCtrl.requalifyClicked = true;
            $state.go("main.accountExam", { assignmentId: vm.assignment.id });
        };
        vm.goToExam = function () {
            $state.go("main.accountExam", { assignmentId: vm.assignment.id });
        };
        vm.goToSelectExamSession = function () {
            //assignmentLearnerAccessOnlineExamResource.getAvailableExamSessions({ id: vm.assignment.id }, function (result) {
            //	vm.data.availableExamSessions = result.toJSON();
            //	console.log(vm.data.availableExamSessions);
            $state.go("main.selectExamSession", { assignmentId: vm.assignment.id, number: $stateParams.number, version: $stateParams.version, code: $stateParams.code });
            //});
        };
        vm.sendAttemptRequest = function () {
            if (vm.form.$valid) {
                vm.formData.id = vm.assignment.id;
                assignmentLearnerAccessOnlineExamResource.requestAttempt(vm.formData, function (result) {
                    vm.data.lastAttemptRequest = result.toJSON();
                }, function (error) {
                    messageService.error(error);
                });
                vm.parentCtrl.sendAttemptRequestClicked = true;
            }
            else {
                vm.showErrors = true;
            }
        };
        vm.redeemCode = function () {
            if (vm.redeemingCode)
                return;
            vm.invalidCode = false;
            vm.redeemingCode = true;
            if (vm.examAttemptCode.trim().length != 36) {
                vm.invalidCode = true;
                vm.redeemingCode = false;
                return;
            }
            vm.formData = {
                id: vm.assignment.id,
                value: vm.examAttemptCode
            };
            assignmentLearnerAccessOnlineExamResource.redeemExamAttemptCode(vm.formData, function (result) {
                if (result.value)
                    $state.reload();
            }, function (error) {
                messageService.error(error);
            });
        };
        vm.purchaseExamAttempt = function () {
            //1 page to come back to after checkout
            $localStorage.examAttemptPurchaseState = {
                number: $stateParams.number,
                version: $stateParams.version,
                code: $stateParams.code
            };
            //2 clear
            shoppingCartService.clear(function () {
                //3 add product to cart
                shoppingCartService.addToCart(vm.data.productId, 1, function () {
                    //4 set purchase type to self
                    var shoppingCart = frameworkService.getCart();
                    shoppingCart.purchaseTypeId = 1;
                    $state.go("main.checkout.step2");
                }, { assignmentIdToAddExamAttempt: vm.assignment.id });
            });
        };
        vm.withdraw = function (examSession) {
            $uibModal.open({
                templateUrl: "withdrawConfirmation.html",
                windowClass: "confirmation-modal",
                controller: ["data", "$scope", function (data, $scope) {
                        var vm = this;
                        vm.withdraw = function () {
                            data.disableButton = true;
                            assignmentLearnerAccessOnlineExamResource.withdraw({ value: data.lastAttemptId }, function () {
                                //data.model.seminars = _.reject(data.model.seminars, data.seminar);
                                load();
                                messageService.success("learningItem.learnerAccess.exam.withdraw.success");
                                $scope.$close();
                            }, function (error) {
                                messageService.error(error);
                                data.disableButton = false;
                            });
                        };
                    }],
                controllerAs: "vm",
                resolve: {
                    data: {
                        activationId: vm.data.activationId,
                        lastAttemptId: vm.data.lastAttemptId,
                        examSession: examSession,
                        model: vm.model,
                        code: vm.code,
                        disableButton: vm.disableButton
                    }
                }
            }).result.catch(angular.noop);
        };
    }
}());
